export const pageWrapperStyle = {
  wrapper: {
    marginTop: { xs: "15%", md: "5%" },
    marginLeft: { xs: "5%", md: "5%" },
    marginRight: { xs: "5%", md: "5%" },
    marginBottom: "2%",
  },
};
